export default {
    VUE_APP_ENV: `local`,
    VUE_APP_URL: `http://localhost:2222`,
    VUE_APP_API_URL: `http://localhost:8100`,
    VUE_APP_G_TAG: `G-XC09CS3FBC`
};
